import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
import {
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../components/ui/table";
import { cn } from "../../../../lib/utils";

interface WorkStepsTableHeaderProps {
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  onSort?: (field: string) => void;
}

const SORTABLE_COLUMNS: Array<{ field: string; label: string }> = [
  { field: "name", label: "WORK STEP NAME" },
  { field: "section", label: "SECTION" },
  { field: "subsection", label: "SUBSECTION" },
  { field: "preparer", label: "PREPARER" },
  { field: "state", label: "STATE" },
];

export const WorkStepsTableHeader = ({
  sortBy,
  sortOrder,
  onSort,
}: WorkStepsTableHeaderProps) => {
  return (
    <TableHeader>
      <TableRow>
        {SORTABLE_COLUMNS.map(({ field, label }, index) => {
          const isSorted = sortBy === field;
          const Icon = isSorted
            ? sortOrder === "asc"
              ? ArrowUp
              : ArrowDown
            : ArrowUpDown;
          return (
            <TableHead
              key={field}
              className={cn(
                "cursor-pointer select-none hover:bg-stone-100 transition-colors border-r sticky top-0 bg-stone-50 z-20 border-y",
                index === 0 && "border-l w-[34%]",
              )}
              onClick={() => onSort?.(field)}
            >
              <div className="flex items-center gap-2 pr-2">
                {label}
                <Icon
                  className={cn(
                    "h-4 w-4",
                    isSorted ? "opacity-100" : "opacity-50",
                  )}
                />
              </div>
            </TableHead>
          );
        })}
      </TableRow>
    </TableHeader>
  );
};
